import React from 'react';
import { userPictureUrl } from '@/lib/media';

export default function MobileDock({ onFeed, onShop, onChat, onUpload, onSearch, onProfile, user, getMediaUrl, activeView }) {
  return (
    <nav className="mobile-dock" aria-label="Navegação móvel">
      <button type="button" onClick={onUpload} aria-label="Publicar"><span className="mobile-publish-mark"><img src="/blop-mini.png?v=1" alt=""/><i className="ti ti-plus"></i></span><span>Publicar</span></button>
      <button type="button" onClick={onFeed} aria-label="Feed" className={activeView === 'feed' ? 'active' : ''}><i className="ti ti-planet"></i><span>Feed</span></button>
      <button type="button" onClick={onShop} aria-label="Loja" className={activeView === 'shop' ? 'active' : ''}><i className="ti ti-shopping-bag-heart"></i><span>Loja</span></button>
      <button type="button" onClick={onChat} aria-label="Conversas" className={activeView === 'chat' ? 'active' : ''}><i className="ti ti-messages"></i><span>Conversas</span></button>
      <button type="button" onClick={onSearch} aria-label="Pesquisar"><i className="ti ti-search"></i><span>Pesquisar</span></button>
      <button type="button" onClick={onProfile} aria-label="Perfil">
        <span className="mobile-dock-avatar"><img src={userPictureUrl(user?.picture,getMediaUrl) || '/blop.png?v=5'} alt="" /></span><span>Perfil</span>
      </button>
    </nav>
  );
}
